
/* eslint-disable no-restricted-syntax */
import {
  defineComponent,
  ref,
  computed,
  watch,
  useContext,
  useFetch,
  useMeta,
} from '@nuxtjs/composition-api';
import { useAlternateLinks } from '@/composables';

export default defineComponent({
  setup() {
    const {
      i18n,
      $api: { categoriesService, documentsService },
    } = useContext();
    const categories = ref([]);
    const searchString = ref(null);

    const fetchCategories = async () => {
      const { data: categoriesData } =
        await categoriesService.getCategoriesWithProductSkus();
      categories.value = categoriesData.filter(
        (category) => category.children && category.children.length,
      );

      const { data: documentsData } =
        await documentsService.getDocumentsGroupedBySku({
          type: 'Certificates',
        });

      for (const category of categories.value) {
        if (category.children && category.children.length) {
          for (const child of category.children) {
            const skus = [];
            for (const sku of child.skus) {
              if (documentsData[sku]) {
                documentsData[sku].forEach((d) => {
                  skus.push(d);
                });
              }
              child.skus = skus;
            }
            child.skus = child.skus.filter((sku) => sku !== undefined);
          }
          category.children = category.children.filter(
            (child) => child.skus.length !== 0,
          );
        }
      }
    };

    useFetch(async () => {
      await fetchCategories();
    });

    const { alternateLinks } = useAlternateLinks();

    useMeta({
      title: i18n.t('certificates'),
      meta: [
        {
          property: 'og:title',
          content: i18n.t('certificates'),
        },
      ],
      link: alternateLinks.value,
    });

    const selectedCategory = ref(null);
    const selectedSubcategory = ref(null);

    const subcategories = computed(
      () =>
        categories.value.find((i) => i.id === selectedCategory.value)?.children,
    );

    const clearFilter = () => {
      selectedCategory.value = null;
      selectedSubcategory.value = null;
    };

    watch(selectedCategory, () => {
      selectedSubcategory.value = null;
    });

    const filterSkus = (skuName) => {
      let cat = JSON.parse(JSON.stringify(categories.value));
      for (const category of cat) {
        if (category.children && category.children.length) {
          for (const child of category.children) {
            child.skus = child.skus.filter((sku) =>
              sku.name.toLowerCase().includes(skuName.toLowerCase()),
            );
          }
          category.children = category.children.filter(
            (child) => child.skus.length !== 0,
          );
        }
      }
      cat = cat.filter((c) => c.children.length !== 0);
      return cat;
    };

    const filteredCategories = computed(() => {
      return searchString.value
        ? filterSkus(searchString.value)
        : categories.value;
    });

    return {
      categories: filteredCategories,
      subcategories,
      selectedCategory,
      selectedSubcategory,
      clearFilter,
      searchString,
    };
  },
  head: {},
});
